import React,{useState} from "react";
import logo from "../assets/images/logo.svg";
import { useNavigate } from 'react-router-dom';

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();

const goToHome = () => {
  navigate('/');
};


  return (
    <div id="header-wrap">
      <header>
        <div className="left">
          <a href="/" className="logo">
            <h1><img src={logo} alt="logo" /></h1>
          </a>
          <button className="btn-menu" onClick={onMenuClick}><i className="fa-solid fa-bars"></i></button>
        </div>
        <div className="right">
          <button className="btn-home" onClick={goToHome}>home</button>
        </div>
      </header>
    </div>
  );
};

export default Header;
